import React, { useState, useEffect, useMemo } from 'react';

import { Popover, Tag } from 'antd';

import styled from 'styled-components';

import { useContact } from '@hooks/API/Contact/UseContact';
import { useContactConnections } from '@hooks/API/Contact/UseContactConnections';

import { NwButton } from '@components/Gui/NwButton';
import NwDivider from '@components/Gui/NwDivider';
import NwDrawer from '@components/Gui/NwDrawer';
import StyleVariables from '@components/Gui/StyleVariables';
import SendDrawer from '@components/SendDrawer/SendDrawer';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const TagHover = styled(Tag)`
    user-select: none;
    cursor: pointer;
    &:hover {
        background-color: ${StyleVariables.PrimaryColor} !important;
    }
`;
const PopoverContent = styled.div`
    color: white;
    .email-item {
        padding: 5px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 12px;
        .email-text {
            margin-right: 20px;
        }
        .remove-email {
            margin-left: auto;
            cursor: pointer;
            user-select: none;
        }
    }
`;

const RecipientsContent = styled.div`
    margin-top: 20px;
    .recipient-row {
        display: flex;
        flex-direction: row;
        .small-line {
            width: 100px;
            height: 1px;
            margin: auto 0;
            background-color: ${StyleVariables.PrimaryDarkLight};
        }
        .agenda-text {
            font-size 14px;
            padding: 0 10px;
        }
        .long-line {
            width: 100%;
            height: 1px;
            margin: auto 0;
            background-color: ${StyleVariables.PrimaryDarkLight};
        }
    }
    .add-recipients {
        text-align: right;
    }
    .recipients-list {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
`;

const Recipients = ({ recipientsData, contactID, onUpdateRecipientsData }) => {
    const { data: currentContact } = useContact(contactID);
    const { data: Connections } = useContactConnections(contactID);

    const [editRecipient, setEditRecipient] = useState(false);

    useEffect(() => {
        if (currentContact && Connections) {
            const { DefaultConnection } = currentContact;
            if (DefaultConnection) {
                onUpdateRecipientsData([
                    {
                        ContactID: DefaultConnection.ContactID,
                        ConnectionID: DefaultConnection.ID,
                        To: DefaultConnection.Email,
                        Ccs: DefaultConnection.CC ? DefaultConnection.CC : [],
                    },
                ]);
            }
        }
    }, [Connections, currentContact]);

    const handleAddEmail = () => () => {
        setEditRecipient(true);
    };

    const handleCloseEmailModal = () => {
        setEditRecipient(false);
    };

    const handleAddeditRecipient = (recipient) => {
        onUpdateRecipientsData([
            ...recipientsData,
            {
                ContactID: recipient.ContactID,
                ConnectionID: recipient.ConnectionID,
                To: recipient.Email,
                Ccs: recipient.CC && recipient.CC.length ? [...recipient.CC] : [],
            },
        ]);
        //handleCloseEmailModal();
    };

    const handleRemoveRecipient = (index) => {
        const _recipientsData = [...recipientsData];
        _recipientsData.splice(index, 1);
        onUpdateRecipientsData([..._recipientsData]);
    };

    const handleRemoveCC = (index, cIndex) => {
        const _recipientsData = [...recipientsData];
        const _Ccs = _recipientsData[index].Ccs;
        _Ccs.splice(cIndex, 1);
        _recipientsData[index].Ccs = [..._Ccs];
        onUpdateRecipientsData([..._recipientsData]);
    };

    const existingEmails = useMemo(() => {
        return recipientsData.map((recipient) => {
            return {
                Email: recipient.To,
                ConnectionID: recipient.ConnectionID,
                ContactID: recipient.ContactID,
                CC: recipient.Ccs,
            };
        });
    }, [recipientsData]);

    return (
        <RecipientsContent>
            {/* <div className="recipient-row">
                <div className="small-line"/>
                <div className="agenda-text">RECIPIENTS</div>
                <div className="long-line"/>
            </div> */}
            <NwDivider textSize="big" dark>
                RECIPIENTS
            </NwDivider>
            <div className="add-recipients">
                <NwButton
                    icon={byPrefixAndName.fass['plus-circle']}
                    ghost
                    label="add recipients"
                    size="small"
                    onClick={handleAddEmail('recipient')}
                />
            </div>
            <div className="recipients-list">
                {recipientsData.map((recipient, index) => {
                    return (
                        <div key={`recipient-${index}`} style={{ marginBottom: '5px' }}>
                            <Popover
                                overlayClassName="recipients-popover"
                                content={
                                    <PopoverContent>
                                        <div>CCs:</div>
                                        {recipient.Ccs &&
                                            recipient.Ccs.map((email, cIndex) => {
                                                return (
                                                    <div
                                                        key={cIndex}
                                                        className="email-item"
                                                        style={{ borderTop: cIndex ? '1px dashed white' : 'none' }}
                                                    >
                                                        <div className="email-text">{email}</div>
                                                        <div
                                                            className="remove-email"
                                                            onClick={() => handleRemoveCC(index, cIndex)}
                                                        >
                                                            X
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </PopoverContent>
                                }
                            >
                                <TagHover
                                    visible
                                    color={StyleVariables.PrimaryDark}
                                    closable
                                    onClose={() => handleRemoveRecipient(index)}
                                >
                                    {recipient.To}
                                    {recipient.Ccs && recipient.Ccs.length > 0 && ` (+${recipient.Ccs.length} CC)`}
                                </TagHover>
                            </Popover>
                        </div>
                    );
                })}
            </div>
            {editRecipient && (
                <NwDrawer padding="0px" title="E-mail Addresses" onClose={handleCloseEmailModal}>
                    <SendDrawer
                        contactID={contactID}
                        searchBox
                        mailingLists={false}
                        suggestions={[]}
                        existingEmails={existingEmails}
                        onSelectRecipient={handleAddeditRecipient}
                    />
                </NwDrawer>
            )}
        </RecipientsContent>
    );
};

export default Recipients;
